import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';

import 'rxjs/add/operator/toPromise';

import {URL_API, HEADERS} from '../constante';
import {AppService} from "../app.service";

@Injectable()
export class ConfigService extends AppService {
    
	executar(comando: string): Promise<Response> {
        this.spinnerService.show();
        return this.http.post(URL_API + '/executar/', JSON.stringify(comando), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }
	
	apagarLogs(): Promise<Response> {
        this.spinnerService.show();
        return this.http.get(URL_API + '/apagar-logs/')
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/config/config.service.ts